import axios from 'axios';
import { EnvironmentConfig } from '../constants.js';

export default {
    name: 'MEMO1Service',
    data() {
        return {
            baseApiUrl: '',
            APIKey: ''
        }
    },
    created: function () {
        //URL and endpoint constants
        this.baseApiUrl = EnvironmentConfig._baseURL;
        this.APIKey = EnvironmentConfig._APIURL;
    },
    methods: {
        DownloadMemoFile(fileName) {
            axios({
                url: this.baseApiUrl + '/api/TaxTransformation/DownloadMemoFiles?fileName=' + fileName,
                method: 'GET',
                headers: {
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                },
                responseType: 'blob',
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            });

        },
        SendMail(sendData) {
            const sendUrl = this.baseApiUrl + '/api/TaxTransformation/SaveSendDetails';
            return axios.post(sendUrl,
                sendData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                }
            }
            ).then(function (response) {
                if (response) {
                    return response;
                }
            }).catch(error => {
                return error;
            });
        },
        GetMemoTemplate() {
            const bankClientDetails = this.baseApiUrl + '/api/TaxTransformation/GetMemoTemplate';
            const params = {
                'userId': localStorage.getItem('userId'),
                'FirstName': localStorage.getItem('firstName'),
                'LastName': localStorage.getItem('lastName'),
                'UserName': localStorage.getItem('userName')
            }
            return axios({
                method: 'post',
                url: bankClientDetails,
                headers: {
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                },
                data: params
            }).then(response => {
                if (response)
                    return response
            }).catch(error => {
                return error;
            })
        },
    }
}

